import React from "react";
import PropTypes from "prop-types";
import TrendingUpIcon from "../../../assets/img/homepage-banner/banner-trending-up.svg";
import DollarIcon from "../../../assets/img/homepage-banner/banner-dollar.svg";
import UnlockIcon from "../../../assets/img/homepage-banner/banner-unlock.svg";
import ChevronRightWhiteIcon from "../../../assets/img/action-center/chevron-right-white.svg";
import { getBannerData } from "./utils";
import {
  BANNER_TITLE,
  BANNER_SUBTITLE,
  BANNER_REVENUE_LABEL,
  BANNER_UNLOCK_LABEL,
  BANNER_UNLOCK_VALUE,
  BANNER_CTA_LABEL,
  BANNER_REVIEW_ALL_HEAP_ID,
} from "./constants";
import "./HomepageBanner.scss";

const HomepageBanner = ({ data = null, v2Data = null, onReviewAll }) => {
  const { show, revenue, hasCorridor } = getBannerData(data, v2Data);

  // Don't show the banner if the main cards are not available.
  if (!show) return null;

  // Ordered metric slots: revenue first, then corridor. A lone metric always
  // lands in slot 1; slot 2 stays blank but reserves its space so the block
  // remains centered.
  const metricItems = [];
  if (revenue) {
    metricItems.push({
      icon: DollarIcon,
      label: BANNER_REVENUE_LABEL,
      value: revenue,
    });
  }
  if (hasCorridor) {
    metricItems.push({
      icon: UnlockIcon,
      label: BANNER_UNLOCK_LABEL,
      value: BANNER_UNLOCK_VALUE,
    });
  }
  const slots = [metricItems[0] || null, metricItems[1] || null];

  return (
    <section className="homepage-banner">
      <div className="homepage-banner__lead">
        <div className="homepage-banner__intro">
          <img
            src={TrendingUpIcon}
            alt=""
            className="homepage-banner__intro-icon"
          />
          <div className="homepage-banner__intro-text">
            <span className="homepage-banner__title">{BANNER_TITLE}</span>
            <span className="homepage-banner__subtitle">{BANNER_SUBTITLE}</span>
          </div>
        </div>
        {/* Divider sits directly after the intro (first) section. */}
        {metricItems.length > 0 && (
          <span className="homepage-banner__divider" />
        )}
      </div>

      {metricItems.length > 0 && (
        <div className="homepage-banner__metrics">
          {slots.map((item, index) => (
            <React.Fragment key={item ? item.label : `blank-${index}`}>
              {index > 0 && (
                <span
                  className={`homepage-banner__divider${
                    metricItems.length < 2
                      ? " homepage-banner__divider--hidden"
                      : ""
                  }`}
                />
              )}
              <div className="homepage-banner__slot">
                {item && (
                  <div className="homepage-banner__metric">
                    <img
                      src={item.icon}
                      alt=""
                      className="homepage-banner__metric-icon"
                    />
                    <div className="homepage-banner__metric-text">
                      <span className="homepage-banner__metric-label">
                        {item.label}
                      </span>
                      <span className="homepage-banner__metric-value">
                        {item.value}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
      )}

      <button
        type="button"
        className="homepage-banner__cta"
        onClick={onReviewAll}
        data-heap-id={BANNER_REVIEW_ALL_HEAP_ID}
      >
        {BANNER_CTA_LABEL}
        <img
          src={ChevronRightWhiteIcon}
          alt=""
          className="homepage-banner__cta-icon"
        />
      </button>
    </section>
  );
};

HomepageBanner.propTypes = {
  data: PropTypes.shape({
    propertyId: PropTypes.number,
    results: PropTypes.shape({
      CORRIDOR: PropTypes.array,
      CORRIDOR_REQUEST: PropTypes.array,
      ARI: PropTypes.array,
      PROMO: PropTypes.array,
      BNBERRY: PropTypes.array,
    }),
  }),
  // Action Centre v2 feed. Decides whether the banner shows; the revenue and
  // unlock metrics stay v1-derived (see getBannerData).
  v2Data: PropTypes.shape({
    propertyId: PropTypes.number,
    cards: PropTypes.array,
  }),
  onReviewAll: PropTypes.func,
};

export default HomepageBanner;
